import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Image_Fragment } from "./image";

export const ImageConnectionMasked_Fragment = graphqlShopifyStorefront(
  `
  fragment ImageConnectionMasked on ImageConnection {
    edges {
      node {
        ...Image
      }
    }
  }
`,
  // [Image_Fragment],
);
